import Page from 'src/components/page/page'

import { Box, Button, Container, IconButton, Tooltip } from '@mui/material'
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs'
import { useAdms } from './adms.hook'
import CNLoading from 'src/components/loading-cn/CNLoading'
import TableRox from 'src/components/table-rox/TableRox'
import { paths } from 'src/routes/paths'
import Iconify from 'src/components/iconify'

export default function Adms() {
  const { TABLEHEADER, isLoadingAdmsList, formattedAdmList, permissions, navigate, onSelectRow, onSelectAllRows, handleDeleteUsers } = useAdms()

  return (
    <Page title='Lista de Administradores'>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="Lista de Administradores"
          links={[]}
          action={
            <Button
              variant="contained"
              onClick={() => navigate(paths.dashboard.admCreate)}
              disabled={!permissions?.create}
            >
              Cadastrar Administrador
            </Button>
          }
        />
        {isLoadingAdmsList ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <TableRox
            header={TABLEHEADER}
            data={formattedAdmList}
            defaultOrderBy="name"
            hasSearch
            onClickKey="id"
            onClickFunction={(id) => navigate(paths.dashboard.admEdit(id))}
            selectKey="email"
            selectType="all"
            onSelectRowFunction={onSelectRow}
            onSelectAllRowFunction={onSelectAllRows}
            selectActions={
              <Tooltip title="Deletar">
                <IconButton color="primary" onClick={() => handleDeleteUsers()} disabled={!permissions?.delete}>
                  <Iconify icon='eva:trash-2-outline' />
                </IconButton>
              </Tooltip>
            }
          />
        )}
      </Container>
    </Page>
  )
}
